import { render, staticRenderFns } from "./OwnModel.vue?vue&type=template&id=7ff90b14&scoped=true&"
import script from "./OwnModel.vue?vue&type=script&lang=js&"
export * from "./OwnModel.vue?vue&type=script&lang=js&"
import style0 from "./OwnModel.vue?vue&type=style&index=0&id=7ff90b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff90b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff90b14')) {
      api.createRecord('7ff90b14', component.options)
    } else {
      api.reload('7ff90b14', component.options)
    }
    module.hot.accept("./OwnModel.vue?vue&type=template&id=7ff90b14&scoped=true&", function () {
      api.rerender('7ff90b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/OwnModel.vue"
export default component.exports